
import { computed, defineComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';

export default defineComponent({
  name: 'profile',
  setup() {
    const store = useStore();

    onMounted(() => {
      setCurrentPageTitle('Thông tin cá nhân');
    });

    return {
      userDetail: computed(() => store.getters.currentUser),
    };
  },
});
